import mori from 'mori';

export default function(data) {
  // The base column is just a version of the first header column
  const baseColumn = mori.set([
    mori.get(mori.first(data.immutableHeaders), 'characteristic'),
    mori.get(mori.first(data.immutableHeaders), 'label'),
  ]);

  // For Geomulti indicators, the second column is the child, so we also need
  // that selector
  const childColumn = mori.getIn(data.config, ['globalRules', 'Geomulti']) ?
    mori.set([
      mori.get(mori.nth(data.immutableHeaders, 1), 'characteristic'),
      mori.get(mori.nth(data.immutableHeaders, 1), 'label'),
    ]) :
    false;

  return [baseColumn, childColumn];
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getColumnKeys.js